/**
 * Compact search overlay toggle (≤1399px o logo centrado):
 * en viewports donde el input desktop no entra (≈1070–1397),
 * o cuando el header usa logo al centro, se muestra solo la lupa.
 */
(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 1399px)');
  const ACTIVE_CLASS = 'lop-mobile-search-active';
  const CLOSING_CLASS = 'lop-mobile-search-closing';
  const OVERFLOW_CLASS = 'overflow-hidden';
  const QUERY_CLASS = 'search-has-query';
  const ANNOUNCEMENT_CLASS = 'lop-mobile-search-show-announcement';

  let searchScrollPos = 0;

  function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function getThemeHeader() {
    return document.querySelector('theme-header');
  }

  function updateHeaderOffset() {
    const headerSection = document.querySelector('.header-section');
    if (headerSection) {
      const offset = headerSection.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', `${offset}px`);
      return;
    }

    const themeHeader = getThemeHeader();
    if (themeHeader && typeof themeHeader.setHeaderOffset === 'function') {
      themeHeader.setHeaderOffset();
    }
  }

  function restoreScrollPosition(scrollPos) {
    // Evitar que html { scroll-behavior: smooth } anime desde top → posición.
    const root = document.documentElement;
    const prevBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';

    if (typeof window.scrollTo === 'function') {
      try {
        window.scrollTo({ top: scrollPos, left: 0, behavior: 'instant' });
      } catch (e) {
        // Older browsers may reject the options object.
        window.scrollTo(0, scrollPos);
      }
    } else {
      window.scrollTo(0, scrollPos);
    }

    root.scrollTop = scrollPos;
    document.body.scrollTop = scrollPos;
    root.style.scrollBehavior = prevBehavior;
  }

  function lockBodyScroll() {
    searchScrollPos = getScrollTop();
    document.body.classList.toggle(ANNOUNCEMENT_CLASS, searchScrollPos <= 1);
    document.body.style.position = 'fixed';
    document.body.style.top = `-${searchScrollPos}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    const scrollPos = searchScrollPos || 0;

    // Mantener transition:none un frame extra (fixed → sticky), igual que el menú.
    document.body.classList.add(CLOSING_CLASS);
    document.body.classList.remove(ACTIVE_CLASS, OVERFLOW_CLASS, ANNOUNCEMENT_CLASS);

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    restoreScrollPosition(scrollPos);
    searchScrollPos = 0;

    requestAnimationFrame(() => {
      restoreScrollPosition(scrollPos);
      updateHeaderOffset();
      requestAnimationFrame(() => {
        document.body.classList.remove(CLOSING_CLASS);
      });
    });
  }

  function isLogoCenter() {
    const header = document.getElementById('header') || document.querySelector('theme-header');
    return !!(header && header.classList.contains('header--logo-center'));
  }

  function isMobile() {
    return MOBILE_MQ.matches || isLogoCenter();
  }

  function getToggles() {
    return document.querySelectorAll('.lop-mobile-search-toggle');
  }

  function getSearchForm() {
    return document.querySelector('search-form.searchform');
  }

  function getSearchInput() {
    return document.getElementById('header-search-input');
  }

  function setToggleState(isOpen) {
    getToggles().forEach((btn) => {
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        isOpen ? btn.dataset.closeLabel : btn.dataset.openLabel
      );
    });
  }

  function resetPredictiveSearch() {
    const searchForm = getSearchForm();
    if (!searchForm) return;

    document.body.classList.remove('open-search');
    document.body.classList.remove(QUERY_CLASS);

    const input = getSearchInput();
    if (input) {
      input.blur();
      input.value = '';
    }

    const wrapper = searchForm.querySelector('.thb-predictive-search-wrapper');
    if (wrapper) {
      wrapper.classList.remove('has-search-term');
    }

    searchForm.querySelectorAll('.thb-predictive-search, .thb-predictive-search-collections').forEach((panel) => {
      panel.setAttribute('inert', '');
    });
  }

  function openSearch() {
    if (!isMobile()) return;

    lockBodyScroll();
    document.body.classList.add(ACTIVE_CLASS, OVERFLOW_CLASS);
    setToggleState(true);
    window.requestAnimationFrame(() => {
      updateHeaderOffset();

      const input = getSearchInput();
      if (input) {
        input.focus({ preventScroll: true });
      }
    });
  }

  function closeSearch() {
    if (!document.body.classList.contains(ACTIVE_CLASS) && !document.body.classList.contains(CLOSING_CLASS)) {
      return;
    }

    setToggleState(false);
    resetPredictiveSearch();
    unlockBodyScroll();
  }

  function toggleSearch() {
    if (document.body.classList.contains(ACTIVE_CLASS)) {
      closeSearch();
    } else {
      openSearch();
    }
  }

  function initToggleLabels() {
    getToggles().forEach((btn) => {
      if (!btn.dataset.openLabel) {
        btn.dataset.openLabel = btn.getAttribute('aria-label') || 'Search';
      }
      if (!btn.dataset.closeLabel) {
        btn.dataset.closeLabel = btn.getAttribute('data-close-label') || 'Close search';
      }
    });
  }

  function syncQueryClass() {
    const input = getSearchInput();
    if (!input || !document.body.classList.contains(ACTIVE_CLASS)) {
      document.body.classList.remove(QUERY_CLASS);
      return;
    }

    if (input.value.trim().length > 0) {
      document.body.classList.add(QUERY_CLASS);
    } else {
      document.body.classList.remove(QUERY_CLASS);
    }
  }

  function clearSearchInput() {
    const input = getSearchInput();
    const searchForm = getSearchForm();
    if (!input) return;

    input.value = '';
    document.body.classList.remove(QUERY_CLASS, 'open-search');

    if (searchForm) {
      const wrapper = searchForm.querySelector('.thb-predictive-search-wrapper');
      if (wrapper) {
        wrapper.classList.remove('has-search-term');
      }

      searchForm.querySelectorAll('.thb-predictive-search, .thb-predictive-search-collections').forEach((panel) => {
        panel.setAttribute('inert', '');
        panel.classList.remove('has-search-term');
      });
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus({ preventScroll: true });
  }

  function watchSearchInput() {
    const input = getSearchInput();
    if (!input) return;

    input.addEventListener('input', syncQueryClass);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('.lop-mobile-search-toggle')) {
      event.preventDefault();
      toggleSearch();
      return;
    }

    if (event.target.closest('.lop-mobile-search-clear')) {
      event.preventDefault();
      clearSearchInput();
    }
  });

  document.addEventListener('keyup', (event) => {
    if (
      event.code &&
      event.code.toUpperCase() === 'ESCAPE' &&
      document.body.classList.contains(ACTIVE_CLASS)
    ) {
      closeSearch();
    }
  });

  MOBILE_MQ.addEventListener('change', (event) => {
    if (!event.matches && !isLogoCenter()) {
      closeSearch();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initToggleLabels();
      watchSearchInput();
    });
  } else {
    initToggleLabels();
    watchSearchInput();
  }
})();
